import ApiService from "../api";
import {encryptEmpfat} from '../EncriptService.js';

const firstCheck = "Estou ciente que o reembolso será recusado, caso a reserva não esteja cancelada e " +
"o número do cartão de crédito não seja informado na solicitação (para emissões internacionais). " + 
"A obrigatoriedade do número do cartão é uma exigência da Cia aérea.";
    

const secondCheck = "Estou ciente que reembolsos 24 horas e solicitações que antecedem a 72 horas da data do voo," +
"deverão ser obrigatoriamente encaminhadas ao e-mail reembolso24h@ancoradouro.com.br, caso contrario, serão tratadas no próximo dia util."

class ReembolsoService extends ApiService {

    static get firstCheck(){
        return firstCheck;
    }

    static get secondCheck(){
        return secondCheck;
    }

    constructor(){
        super('/portal/solicitacao')
    }

    salvar(solicitacao){
        let code = localStorage.getItem("codigoEmpresaSelecionada")
        if(code){
            solicitacao = { ...solicitacao, empfat: code};
        }
        return this.post('/saveSolicitacao', encryptEmpfat(solicitacao))
    }

    listar(filtro){
        return this.post('/listarSolicitacoes', encryptEmpfat(filtro));
    }

    enviarEmails(solicitacoes){
        return this.post('/sendEmail', solicitacoes)
    }

    pegarUsuarioSolicitacao(codemp){
        return this.post("/userSolicitacao", codemp)
    }
}

export default ReembolsoService;